exports.lang = {
    "스토리 번역용":"스토리"
};
